import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";
import moment from 'moment';

const UnassignCar = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, selectedCars }) => {
  const apiCall = useApiCall();

  const validationSchema = yup.object({
    returnDate: yup
      .string('This Field is Required')
      .required('This Field is Required'),
  });

  const formik = useFormik({
    initialValues: {
      returnDate: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      console.log("Values", values);
      const cleaned = selectedCars.filter(v => (v !== undefined && v !== null));
      const apiCars = cleaned?.map((eachCar, i) => {return {"car_id": eachCar}})

      let data = {
        "cars": apiCars,
        "return_date": moment(values?.returnDate).format("DD-MM-YYYY")
      }

      try {
        let apiRes = await apiCall({ method: "post", url: "unassign-car-to-user", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(`${error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong"}`)
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal}`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>Unassign Car</h4>
          <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea}`}>
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Return Date</label>
                    {/* <input type="date" placeholder='Type Here' /> */}
                    <input
                      type="date"
                      name='returnDate'
                      value={formik.values.returnDate}
                      onChange={formik.handleChange}
                    />
                    {
                      (formik.touched.returnDate && Boolean(formik.errors.returnDate)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.returnDate && formik.errors.returnDate}</span>
                        :
                        null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default UnassignCar